<section class="sign-step">
  <ng-container *ngIf="!alreadySigned; else signed">
    <header class="sign-step__intro">
      <h2 class="sign-step__title">Review and sign your {{ isApplication ? "MSA" : "loan" }} agreement</h2>

      <p class="sign-step__body">
        Your agreement is ready. It includes
        <ng-container *ngIf="summary?.stateName">{{ summary.stateName }} </ng-container>disclosures
        and your {{ summary?.productName ?? "loan" }} Agreement. All owner signatures are required
        before funds can be accessed.
      </p>

      <span class="sign-step__powered-by">
        <span class="sign-step__powered-by-label">Powered by</span>
        <span class="sign-step__docusign-logo">
          <img src="assets/docusign-logo.png"
               alt="DocuSign" />
        </span>
      </span>
    </header>

    <div class="sign-step__summary"
         *ngIf="summary">
      <div class="sign-step__summary-title">{{ summaryTitle }}</div>

      <div class="sign-step__summary-figures">
        <div class="sign-step__figure">
          <div class="sign-step__figure-value">{{ summary.amount | currency }}</div>
          <div class="sign-step__figure-label">{{ summary.amountLabel }}</div>
        </div>
        <div class="sign-step__figure">
          <div class="sign-step__figure-value">{{ summary.repaymentTerm }} months</div>
          <div class="sign-step__figure-label">Term</div>
        </div>
        <div class="sign-step__figure">
          <div class="sign-step__figure-value">{{ summary.paymentFrequencyLabel }}</div>
          <div class="sign-step__figure-label">Payment frequency</div>
        </div>
      </div>
    </div>

    <div class="sign-step__ceremony">
      <!-- Rendered unconditionally: the SDK cannot mount into an element that is not in the document. -->
      <div class="sign-step__frame"
           [class.sign-step__frame--empty]="!mounted"
           #ceremony></div>

      <div class="sign-step__frame sign-step__frame--placeholder"
           *ngIf="failed">
        <p class="sign-step__body">
          The agreement could not be opened. Nothing has been signed — please try again.
        </p>
        <button mat-flat-button
                color="primary"
                (click)="retry()">Try again</button>
      </div>

      <!-- Inline spinner, not ifp-spinner-loading: that one is a whole-page blocker. -->
      <div class="sign-step__scrim"
           *ngIf="starting || finishing">
        <mat-spinner diameter="45"></mat-spinner>
      </div>
    </div>

    <span class="sign-step__powered-by sign-step__powered-by--footer">
      <span class="sign-step__powered-by-label">Powered by</span>
      <span class="sign-step__docusign-logo">
        <img src="assets/docusign-logo.png"
             alt="DocuSign" />
      </span>
    </span>
  </ng-container>

  <ng-template #signed>
    <header class="sign-step__intro">
      <h2 class="sign-step__title">You have signed this agreement</h2>

      <p class="sign-step__body"
         *ngIf="outstandingSignerNames.length; else fullySigned">
        We are still waiting for
        <span class="sign-step__signers">{{ outstandingSigners }}</span> to sign. Your
        {{ isApplication ? "agreement is executed" : "loan opens" }} once everyone has, and we will email you then.
      </p>

      <ng-template #fullySigned>
        <p class="sign-step__body">
          Thank you. Every owner has signed, so your {{ isApplication ? "agreement is executed" : "loan is opening now" }}.
        </p>
      </ng-template>
    </header>
  </ng-template>
</section>
